module.exports = __webpack_public_path__ + "img/ot3.9b830e99.png";